/** Save text the dashboard already fetched (authenticated) as a file download. */
export function downloadText(filename: string, text: string, type = 'text/csv') {
    const url = URL.createObjectURL(new Blob([text], { type }))
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
}
